export enum Reusability {
  Reusable = 'Could be reused',
  NotReusable = 'To be recycled',
  Unknown = 'Unknown'
}
